module.exports = __webpack_public_path__ + "img/I+D+I.819b9829.png";